import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { useWindowSize } from "@shared/lib/hooks/useWindowSize";
import { PLACEHOLDER_ADS_TEXT } from "@shared/ui/AdBlock/constants";
import { AdBlockProps } from "./adblock-props.interface";
import classes from "./AdBlock.module.scss";

export const AdBlock = ({ blockId, ownerId, isAdfox = false }: AdBlockProps) => {
    const pathname = usePathname();
    const { width } = useWindowSize();
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const shouldShowPlaceholder = isLoading || hasError;

    const handleRenderFail = () => {
        setIsLoading(false);
        setHasError(true);
    };

    useEffect(() => {
        handleRenderFail();
        if (typeof window !== "undefined") {
            const Ya = window.Ya;
            if (window.yaContextCb && Ya?.Context?.AdvManager) {
                if (!isAdfox) {
                    window.yaContextCb.push(() => {
                        Ya?.Context?.AdvManager?.render({
                            blockId: blockId || "",
                            renderTo: `yandex_rtb_${blockId}`,
                            async: true,
                            onRenderComplete: () => {
                                setIsLoading(false);
                            },
                            onRenderFail: handleRenderFail
                        });
                    });
                } else {
                    window.yaContextCb.push(() => {
                        const existingContainer = document.getElementById(`adfox_${blockId}`);
                        if (existingContainer && existingContainer.children.length > 0) {
                            return;
                        }

                        Ya?.adfoxCode?.create({
                            ownerId: ownerId || "",
                            containerId: `adfox_${blockId}`,
                            params: {
                                pp: "g",
                                ps: "juqb",
                                p2: "jnyl"
                            },
                            onRender: () => {
                                setIsLoading(false);
                            },
                            onError: handleRenderFail
                        });
                    });
                }
            } else {
                handleRenderFail();
            }
        }
    }, [pathname, width]);

    return (
        <>
            {!isAdfox && (
                <div id={`yandex_rtb_${blockId}`} className={classes.adblock}>
                    {shouldShowPlaceholder && (
                        <div className={classes.adblock__placeholder}>{PLACEHOLDER_ADS_TEXT}</div>
                    )}
                </div>
            )}

            {isAdfox && <div id={`adfox_${blockId}`} className={classes.adblockFox}></div>}
        </>
    );
};